import React from 'react';
import Card from 'react-bootstrap/Card';

import Header from './header';
import Pane from './pane';
import withNameInput from './hoc-input';

const DpFundSize = withNameInput('dpFundSize', 'Fund Size', true);
const DpFundSizeDate = withNameInput('dpFundSizeDate', 'Fund Size Date', true);

export default function DpFundNetAssets() {
  const event = 'dpNetAssets';

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Net Assets from Data Provider</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          <DpFundSize />
          <DpFundSizeDate />
        </Card.Body>
      </Pane>
    </Card>
  );
}
